import { uid } from 'quasar';

export const defaultComponentName = 'str';

export const componentReference = [
  'time',
  'user',
  'users',
  'operator',
  'status',
  'str',
  'sub_org_id',
  'event',
  'cronjob',
  'field_value',
  'field_name',
  'doc_type',
  'sub_doc_type',
  'priority',
  'math_operator',
  'method',
  'send_email',
  'table_name',
  'table_column_name',
  'order_data',
  'groups',
  'table_column_name_compare',
  'table_column_name_compare_to',
  'table_column_name_dependency',
  'table_column_name_left',
  'table_column_name_right',
  'column_name_dependency',
  'result_column_name',
  'recipient',
  'field_status',
  'workflow',
  'boolean',
  'tolerance_amount',
  'tolerance_type',
  'condition_result',
  'master_data_table',
  'operator_any_all',
  'minutes',
  'ignore_pending_tasks',
  'export_configuration',
  'region',
  'date',
  'decision_table',
  'module',
  'use_decision_table',
  'assignee_type',
  'trigger_docflow',
  'comparison_data',
  'task_type',
  'store_data',
  'script',
  'script_data',
  'po_column',
  'supplier_item',
  'docoperators_run_env',
  'po_import_type',
  'po_db_column',
  'po_db_table',
  'delivery_date_type',
  'supplier_type',
  'allowed_tolerance_days',
  'wf_supplier_status',
  'email_recipient',
  'email_templates',
];

export const WorkFlowBuilder = {
  data() {
    return {
      fields: {
        criteria: {
          id: uid(),
          name: '',
          criteria_to_update: 'all_conditions',
          type: 'and',
          condition_elements: [],
        },
        action: {
          id: uid(),
          name: '',
          type: '',
          action_elements: [],
        },
      },

      condition_fields: {
        key: '',
        match_type: 'eq',
        value: '',
      },

      action_fields: {
        field: '',
        value: '',
      },
    };
  },
};
